import { ConversationInterface } from './conversation.interface';

export interface ConversationStreamInterface {
  userUnreadMessagesCount?: number;
  conversations?: ConversationInterface[];
}
